<template>
  <div>
    <!-- Start Page Title -->
    <div v-if="false" class="page-title-area">
      <div class="d-table">
        <div class="d-table-cell">
          <div class="container">
            <h2>Products Details</h2>
          </div>
        </div>
      </div>
    </div>
    <!-- End Page Title -->

    <!-- Start Shop Details Area -->
    <section class="shop-details-area ptb-80">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-lg-5">
            <div class="products-details-image">
              <product-details-image :product="product" />
            </div>
          </div>

          <div class="col-lg-7">
            <div class="products-details">
              <h3>{{ product.name }}</h3>

              <div class="price">
                <span>${{ product.price }}</span>
              </div>
              <ul v-if="v2" class="rating">
                <li><i class="flaticon-star-1"></i></li>
                <li><i class="flaticon-star-1"></i></li>
                <li><i class="flaticon-star-1"></i></li>
                <li><i class="flaticon-star-1"></i></li>
                <li><i class="flaticon-star-1"></i></li>
              </ul>

              <p>{{ product.summary }}</p>

              <div class="availability">
                Availability: <span>In Stock</span>
              </div>

              <AddToCartDetails
                :product="product"
                @add-to-cart="handleAddToCartClick"
                @buy-now="handleBuyNowClick"
                @product-increment="handleIncrementClick"
                @product-decrement="handleDecrementClick"
              />

              <div class="custom-payment-options">
                <span>Guaranteed safe checkout:</span>

                <div class="payment-methods">
                  <img src="@/assets/img/payment-image/1.svg" alt="image" />
                  <img src="@/assets/img/payment-image/2.svg" alt="image" />
                  <img src="@/assets/img/payment-image/3.svg" alt="image" />
                  <img src="@/assets/img/payment-image/4.svg" alt="image" />
                  <img src="@/assets/img/payment-image/5.svg" alt="image" />
                  <img src="@/assets/img/payment-image/6.svg" alt="image" />
                  <img src="@/assets/img/payment-image/7.svg" alt="image" />
                </div>
              </div>

              <div class="products-share-social">
                <span>Share:</span> <social-link-share />
              </div>
            </div>
          </div>

          <div class="col-lg-12 col-md-12">
            <div class="products-details-tabs">
              <ul id="tabs">
                <li class="active" id="tab_1">Description</li>
              </ul>

              <div class="content show" id="tab_1_content">
                <div class="products-description">
                  <tip-tap-output
                    v-if="product.description"
                    :content="product.description"
                    :show-less-char="200"
                    :use-dots="true"
                  />
                  <ul v-if="v2" class="additional-information">
                    <li><span>Brand</span> ThemeForest</li>
                    <li><span>Color</span> Brown</li>
                    <li><span>Size</span> Large, Medium</li>
                    <li><span>Weight</span> 27 kg</li>
                    <li><span>Dimensions</span> 16 x 22 x 123 cm</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- End Shop Details Area -->
  </div>
</template>

<script>
import ProductDetailsImage from "../common/productDetailsImage";
import AddToCartDetails from "../common/addToCartDetails";
import SocialLinkShare from "@/components/common/socialLinkShare";
import TipTapOutput from "@/components/common/tipTapOutput";
export default {
  name: "ProductDetails",
  components: {
    AddToCartDetails,
    ProductDetailsImage,
    SocialLinkShare,
    TipTapOutput
  },
  props: {
    product: {
      type: Object,
      required: false,
      default: () => {}
    }
  },
  data() {
    return {
      v2: false
    };
  },
  methods: {
    handleAddToCartClick() {
      this.$emit("add-to-cart", this.product);
    },
    handleBuyNowClick() {
      this.$emit("buy-now", this.product);
    },
    handleIncrementClick(product, itemNumber) {
      this.$emit("product-increment", product, itemNumber);
    },
    handleDecrementClick(product, itemNumber) {
      this.$emit("product-decrement", product, itemNumber);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../assets/style/style.scss";
.products-details-image {
  .slickslide {
    padding-left: 0;
    margin-bottom: 0;
    list-style-type: none;

    li {
      img {
        width: 100%;
      }
    }
  }
}
.products-details {
  h3 {
    font-size: 20px;
    margin-bottom: 8px;
  }
  .price {
    margin-bottom: 15px;

    span {
      text-decoration: line-through;
      color: $paragraph-color;
    }
  }
  .rating {
    padding: 0;
    margin: 0 0 12px;
    list-style-type: none;

    li {
      display: inline-block;
      color: #eac11d;

      i {
        &::before {
          font-size: 15px;
        }
      }
    }
  }
  .availability {
    margin-bottom: 20px;

    span {
      color: #ffc729;
    }
  }
  form {
    .quantity {
      display: inline-block;
      padding-right: 10px;

      span {
        padding-right: 10px;
      }
      .input-counter {
        max-width: 110px;
        min-width: 110px;
        text-align: center;
        display: inline-block;
        position: relative;
        border: 1px solid #eeeeee;
        padding: {
          top: 8px;
          bottom: 8px;
        }
        span {
          position: absolute;
          top: 0;
          background-color: transparent;
          cursor: pointer;
          color: $paragraph-color;
          width: 40px;
          height: 100%;
          line-height: 47px;
          transition: $transition;
          padding: 0;

          &.minus-btn {
            left: 0;
          }
          &.plus-btn {
            right: 0;
          }
          svg {
            width: 20px;
          }
          &:hover {
            color: #ffc729;
          }
        }
      }
    }
    button {
      background: #ffc729;
      color: $white-color;
      border: none;
      height: 46px;
      padding: 0 20px;
      position: relative;
      top: -3px;
      cursor: pointer;
      outline: 0;
      transition: $transition;

      &:hover,
      &:focus {
        background-color: $purple-color;
        color: $white-color;
      }
    }
    .add-to-wishlist-btn {
      margin-left: 5px;
      background: transparent;
      color: $black-color;
      border: 1px solid #eeeeee;
      position: relative;
      top: -3px;
      cursor: pointer;
      outline: 0;
      transition: $transition;
      width: 45px;
      height: 45px;
      text-align: center;
      line-height: 45px;

      &:hover,
      &:focus {
        background-color: $purple-color;
        color: $white-color;
        border-color: $purple-color;
      }
      .feather {
        position: relative;
        top: 4px;
        overflow: unset;
      }
    }
    .buy-btn {
      margin-top: 20px;

      .btn-primary {
        background: $purple-color;
        box-shadow: 0 13px 27px 0 rgba(198, 121, 227, 0.25);

        &::after,
        &::before {
          background: #ffc729;
          box-shadow: 0 13px 27px 0 rgba(68, 206, 111, 0.25);
        }
      }
    }
  }
  .custom-payment-options {
    margin-top: 20px;

    span {
      display: block;
      margin-bottom: 10px;
    }
    .payment-methods {
      img {
        display: inline-block;
        margin-right: 5px;
      }
    }
  }
  .products-share-social {
    margin-top: 25px;

    span {
      display: inline-block;
      margin-right: 10px;
      position: relative;
      top: -3px;
    }
    ul {
      padding: 0;
      margin: 0;
      list-style-type: none;
      display: inline-block;

      li {
        display: inline-block;
        margin-right: 5px;

        a {
          width: 32px;
          text-align: center;
          line-height: 37px;
          height: 32px;
          border: 1px solid $light-green-color;
          border-radius: 50%;
          color: $light-green-color;

          svg {
            width: 15px;
          }
          &.facebook {
            border-color: #4267b2;
            color: #4267b2;

            &:hover {
              background: #4267b2;
              color: $white-color;
            }
          }
          &.twitter {
            border-color: #38a1f3;
            color: #38a1f3;

            &:hover {
              background: #38a1f3;
              color: $white-color;
            }
          }
          &.linkedin {
            border-color: #0077b5;
            color: #0077b5;

            &:hover {
              background: #0077b5;
              color: $white-color;
            }
          }
          &.instagram {
            border-color: #231f20;
            color: #231f20;

            &:hover {
              background: #231f20;
              color: $white-color;
            }
          }
          &:hover {
            background: $light-green-color;
            color: $white-color;
          }
        }
      }
    }
  }
}
.products-details-tabs {
  margin-top: 40px;
  text-align: center;

  #tabs {
    padding: 0;
    margin: 0 0 30px;
    list-style-type: none;

    li {
      display: inline-block;
      padding: 12px 50px 8px;
      cursor: pointer;
      margin-right: -4px;
      transition: $transition;
      background: #eaeaea;
      font: {
        weight: 500;
      }
      &.active {
        background-color: $white-color;
        position: relative;

        &::before {
          content: "";
          position: absolute;
          width: 100%;
          height: 4px;
          top: 0;
          left: 0;
          background: #ffc729;
        }
      }
      &.inactive {
        background-color: #eeeeee;
        padding: 12px 50px;
      }
    }
  }
  .content {
    display: none;

    &.show {
      display: block;
    }
    h3 {
      margin-bottom: 12px;
      font: {
        size: 18px;
      }
    }
    .additional-information {
      padding: 0;
      margin: 25px 0 0;
      list-style-type: none;
      text-align: left;

      li {
        border: 1px solid #eeeeee;
        border-bottom: none;
        padding: 10px 15px;
        color: $paragraph-color;

        &:last-child {
          border-bottom: 1px solid #eeeeee;
        }
        span {
          display: inline-block;
          width: 45%;
        }
      }
    }
    .products-reviews {
      text-align: left;
      max-width: 700px;
      margin: 0 auto;

      p {
        margin-bottom: 0;
      }
      .review-form {
        margin-top: 20px;
        max-width: 620px;

        p {
          margin-bottom: 0;
        }
        .form-control {
          background: transparent;
        }
      }
      .star-source {
        width: 0;
        height: 0;
        margin-top: 5px;
        visibility: hidden;

        svg {
          width: 1.5rem;
          height: 1.5rem;
          padding: 0 0.15rem;
        }
      }
      .star-rating {
        display: flex;
        flex-direction: row-reverse;
        justify-content: center;
        width: 105px;
        margin-bottom: 10px;

        label {
          cursor: pointer;

          .star {
            color: transparent;
            transition: color 0.2s ease-in-out;
          }
        }
        label:hover ~ label .star,
        svg.star:hover,
        input[name="star"]:focus ~ label .star,
        input[name="star"]:checked ~ label .star {
          color: #f2b01e;
        }
        svg {
          width: 1.5rem;
          height: 1.5rem;
          padding: 0 0.15rem;
        }
        input {
          &[name="star"] {
            display: inline-block;
            width: 0;
            opacity: 0;
            margin-left: -2px;
          }
          &[name="star"]:checked {
            + label {
              animation: scaleup 1s;

              .star {
                animation: starred 0.5s;
              }
            }
          }
        }
      }
    }
  }
}
.custom-payment-options {
  margin-top: 20px;

  span {
    display: block;
    margin-bottom: 10px;
  }
  .payment-methods {
    img {
      display: inline-block;
      margin-right: 5px;
    }
  }
}
.products-share-social {
  margin-top: 25px;

  span {
    display: inline-block;
    margin-right: 10px;
    position: relative;
    top: -3px;
  }
  ul {
    padding: 0;
    margin: 0;
    list-style-type: none;
    display: inline-block;

    li {
      display: inline-block;
      margin-right: 5px;

      a {
        width: 32px;
        text-align: center;
        line-height: 37px;
        height: 32px;
        border: 1px solid $light-green-color;
        border-radius: 50%;
        color: $light-green-color;

        svg {
          width: 15px;
        }
        &.facebook {
          border-color: #4267b2;
          color: #4267b2;

          &:hover {
            background: #4267b2;
            color: $white-color;
          }
        }
        &.twitter {
          border-color: #38a1f3;
          color: #38a1f3;

          &:hover {
            background: #38a1f3;
            color: $white-color;
          }
        }
        &.linkedin {
          border-color: #0077b5;
          color: #0077b5;

          &:hover {
            background: #0077b5;
            color: $white-color;
          }
        }
        &.instagram {
          border-color: #231f20;
          color: #231f20;

          &:hover {
            background: #231f20;
            color: $white-color;
          }
        }
        &:hover {
          background: $light-green-color;
          color: $white-color;
        }
      }
    }
  }
}
.content {
  display: none;

  &.show {
    display: block;
  }
  h3 {
    margin-bottom: 12px;
    font: {
      size: 18px;
    }
  }
  .additional-information {
    padding: 0;
    margin: 25px 0 0;
    list-style-type: none;
    text-align: left;

    li {
      border: 1px solid #eeeeee;
      border-bottom: none;
      padding: 10px 15px;
      color: $paragraph-color;

      &:last-child {
        border-bottom: 1px solid #eeeeee;
      }
      span {
        display: inline-block;
        width: 45%;
      }
    }
  }
  .products-reviews {
    text-align: left;
    max-width: 700px;
    margin: 0 auto;

    p {
      margin-bottom: 0;
    }
    .review-form {
      margin-top: 20px;
      max-width: 620px;

      p {
        margin-bottom: 0;
      }
      .form-control {
        background: transparent;
      }
    }
    .star-source {
      width: 0;
      height: 0;
      margin-top: 5px;
      visibility: hidden;

      svg {
        width: 1.5rem;
        height: 1.5rem;
        padding: 0 0.15rem;
      }
    }
    .star-rating {
      display: flex;
      flex-direction: row-reverse;
      justify-content: center;
      width: 105px;
      margin-bottom: 10px;

      label {
        cursor: pointer;

        .star {
          color: transparent;
          transition: color 0.2s ease-in-out;
        }
      }
      label:hover ~ label .star,
      svg.star:hover,
      input[name="star"]:focus ~ label .star,
      input[name="star"]:checked ~ label .star {
        color: #f2b01e;
      }
      svg {
        width: 1.5rem;
        height: 1.5rem;
        padding: 0 0.15rem;
      }
      input {
        &[name="star"] {
          display: inline-block;
          width: 0;
          opacity: 0;
          margin-left: -2px;
        }
        &[name="star"]:checked {
          + label {
            animation: scaleup 1s;

            .star {
              animation: starred 0.5s;
            }
          }
        }
      }
    }
  }
}
</style>
